import { IntakeFormFile } from '~/types/IntakeFormFile';

/**
 * The fileName is the base name of the file, and sometimes ends with a trailing dot.
 * Trim the dot if it exists, and add the fileType to the end (which is a dot-prefixed extension)
 */
export const getFullIntakeFormFileName = (file: IntakeFormFile) =>
  `${file.fileName.replace(/\.$/, '')}${file.fileType}`;
